import * as Api from "../../utils/api/api.js";
import translate from "components/translations/translations.wrapper";
import { Account, CostUnitOrganisation } from "types/organisationUnit";
import { AdvancedSearchProps } from "types/advancedSearch";
import AdvancedSearchInput from "components/input/AdvancedSearchInput.component";
import * as reduxSelectors from "components/store/application.reducers";
import {connect} from "react-redux";
import { Button, ButtonType } from "components/common/Button.component";
import { Trash2 } from "lucide-react";
import { ICON_SIZE } from "components/common/constants";


export function AdvancedSearchFiltering(props: AdvancedSearchProps) {

    const computeSelectedValue = function(data: Account | CostUnitOrganisation) {
        if (data.selectedValue) {
            return {
                label: data.label,
                value: data.selectedValue,
            };
        }
        return null;

    };
    const organizationTypes = props.costUnits.map((org: CostUnitOrganisation) => {
        const cuLabel = props.translate("myHistory.selectCostUnit", org.name);
        return (
            <AdvancedSearchInput key={org.name + "+" + org.dimension}
                                 placeholder={cuLabel}
                                 name={org.name}
                                 type={Api.lookupCostCenters}
                                 selectedValue={computeSelectedValue(org)}
                                 dimension={org.dimension}
                                 onSearch={props.onSearch}
                                 onChange={props.onSearch.bind(null, org.dimension)}
                                 translate={props.translate}
                                 companyId={props.companyId}/>
        );
    });

    const accountLabel = props.translate("myHistory.selectAccount");
    const accountingLookup = (<AdvancedSearchInput
        key={"accounting"}
        placeholder={accountLabel}
        name={props.translate("myHistory.account")}
        dimension={null}
        type={Api.lookupAccount}
        selectedValue={computeSelectedValue(props.account)}
        onSearch={props.onSearch}
        onChange={props.onAccountSearch.bind(null)}
        translate={props.translate}
        companyId={props.companyId}/>);

    return (

        <div className="panel-body new-advanced-search-container">
            <div className="row col-md-12 btn-toolbar-advanced advanced-search-header">
                <div className="col-auto mr-auto px-0 title">Advanced search</div>
                <div className="col-auto mr-10">
                    <Button type={ButtonType.GHOST}
                            onClick={props.onClearFilters}
                            extraClassName={"float-right ml-6"}
                            disabled={!props.isClearActive}
                            text={props.translate("myHistory.clearAllFilters")}
                            icon={<Trash2 size={ICON_SIZE.MEDIUM}/>}
                    />
                </div>
            </div>
            <div className="row col-md-12 advanced-search-header-border margin-bottom-8"></div>
            <div className="row col-md-12">
                {organizationTypes}
                {accountingLookup}
            </div>
        </div>
    );

}


const mapStateToProps = function (store) {
    return {
        companyId: reduxSelectors.getUsersCurrentContextId(store)
    };
};
const withTranslations = translate(AdvancedSearchFiltering);
const connected:any = connect(mapStateToProps, {})(withTranslations);

export default connected;

// const withTranslations = translate(AdvancedSearchFiltering);
// export default withTranslations;
